// Study Navbar - Menu "More" functionality
// Moves nav items that don't fit into a "More" dropdown menu

(function() {
  'use strict';

  let isInitialized = false;
  let resizeObserver = null;

  function initStudyNavbar() {
    const navbar = document.querySelector('.study-navbar');
    if (!navbar) return;

    const navItemsContainer = navbar.querySelector('.nav-items-container');
    const navLinksContainer = navbar.querySelector('.nav-links-container');
    const navLinksGroup = navbar.querySelector('.nav-links-group');
    const navMoreMenu = navbar.querySelector('.nav-more-menu');
    const navMoreDropdown = navbar.querySelector('.nav-more-dropdown');
    const navMoreCounter = navbar.querySelector('.nav-more-counter');
    const titleWrapper = navbar.querySelector('.study-name-wrapper');

    if (!navLinksContainer || !navLinksGroup || !navMoreMenu || !navMoreDropdown || !navItemsContainer) return;

    // Store original nav items data (excluding More menu)
    const originalItems = [];
    const navItems = navLinksGroup.querySelectorAll('.nav-item:not(.nav-more-menu)');
    
    navItems.forEach((item) => {
      const link = item.querySelector('.nav-link');
      if (link) {
        // Measure the natural/minimum width of each item
        const computedStyle = window.getComputedStyle(link);
        
        // Create a temporary span to measure text width
        const tempSpan = document.createElement('span');
        tempSpan.style.cssText = `
          visibility: hidden;
          position: absolute;
          white-space: nowrap;
          font-size: ${computedStyle.fontSize};
          font-family: ${computedStyle.fontFamily};
          font-weight: ${computedStyle.fontWeight};
        `;
        tempSpan.textContent = link.textContent.trim();
        document.body.appendChild(tempSpan);
        const textWidth = tempSpan.offsetWidth;
        document.body.removeChild(tempSpan);
        
        // Minimum width = text width + minimum padding (32px total)
        const minWidth = textWidth + 32;
        
        originalItems.push({
          href: link.href,
          text: link.textContent.trim(),
          isActive: link.classList.contains('active'),
          ariaCurrent: link.getAttribute('aria-current'),
          minWidth: minWidth
        });
      }
    });

    // Ensure More menu is at the end
    navLinksGroup.appendChild(navMoreMenu);

    function updateCounter(count) {
      if (navMoreCounter) {
        navMoreCounter.textContent = count;
        navMoreCounter.style.display = count > 0 ? 'inline-flex' : 'none';
      }
    }

    function calculateAvailableSpace() {
      // Get viewport width (what user sees)
      const viewportWidth = window.innerWidth;
      
      // Get the navbar's left position in viewport
      const navbarRect = navbar.getBoundingClientRect();
      const navbarLeft = navbarRect.left;
      
      // Calculate the width available for the navbar container
      // This is: viewport width - navbar's left position - right padding
      const navbarPadding = 58; // padding on navbar (left + right)
      const containerWidth = viewportWidth - navbarLeft - navbarPadding;
      
      // Set the container width dynamically
      navItemsContainer.style.width = `${Math.max(containerWidth, 300)}px`;
      
      // Get title width
      const titleWidth = titleWrapper ? titleWrapper.offsetWidth : 0;
      const titleMargin = 20; // margin-right on title
      const navLinksContainerPadding = 20; // Additional padding/margin for nav-links-container to ensure proper spacing
      
      // Calculate available space for nav items
      const availableSpace = containerWidth - titleWidth - titleMargin - navLinksContainerPadding;

      return {
        viewportWidth,
        containerWidth,
        titleWidth,
        availableSpace
      };
    }

    function checkOverflow() {
      // Reset: Clear dropdown and restore all items to navbar
      navMoreDropdown.innerHTML = '';
      navMoreMenu.style.display = 'none';
      updateCounter(0);
      
      // Remove current items (except More menu)
      const currentItems = navLinksGroup.querySelectorAll('.nav-item:not(.nav-more-menu)');
      currentItems.forEach(item => item.remove());
      
      // Restore all original items
      originalItems.forEach((data) => {
        const li = document.createElement('li');
        li.className = 'nav-item';
        li.dataset.minWidth = data.minWidth;
        
        const link = document.createElement('a');
        link.className = 'nav-link';
        link.href = data.href;
        link.textContent = data.text;
        
        if (data.isActive) {
          link.classList.add('active');
        }
        if (data.ariaCurrent) {
          link.setAttribute('aria-current', data.ariaCurrent);
        }
        
        li.appendChild(link);
        navLinksGroup.insertBefore(li, navMoreMenu);
      });

      // Force layout recalculation
      void navLinksGroup.offsetWidth;

      const { availableSpace } = calculateAvailableSpace();
      
      // Get all visible nav items
      const visibleItems = Array.from(navLinksGroup.querySelectorAll('.nav-item:not(.nav-more-menu)'));
      
      if (visibleItems.length === 0) return;

      // Calculate total minimum width needed for all items
      const totalMinWidth = originalItems.reduce((sum, item) => sum + item.minWidth, 0);
      
      // Check if all items fit at minimum width
      const needsMore = totalMinWidth > availableSpace;

      if (!needsMore) {
        // All items fit - let them grow to fill space
        visibleItems.forEach(item => {
          item.style.flex = '1 1 auto';
        });
        return;
      }

      // Show More menu and calculate its width
      navMoreMenu.style.display = 'flex';
      void navMoreMenu.offsetWidth;
      
      const moreMenuWidth = navMoreMenu.offsetWidth || 100;
      const spaceForItems = availableSpace - moreMenuWidth - 10; // 10px safety margin

      // Calculate which items can fit at their minimum width
      const itemsToMove = [];
      let usedWidth = 0;
      let itemsThatFit = 0;

      // Iterate from left to right, keeping items that fit at minimum width
      for (let i = 0; i < originalItems.length; i++) {
        const itemMinWidth = originalItems[i].minWidth;
        
        if (usedWidth + itemMinWidth <= spaceForItems) {
          usedWidth += itemMinWidth;
          itemsThatFit++;
        } else {
          // This item and all remaining items go to More menu
          for (let j = i; j < visibleItems.length; j++) {
            itemsToMove.push(visibleItems[j]);
          }
          break;
        }
      }

      // If no items fit, move all to More menu
      if (spaceForItems <= 0 || itemsThatFit === 0) {
        itemsToMove.length = 0; // Clear
        itemsToMove.push(...visibleItems);
      }

      // Move items to More dropdown
      itemsToMove.forEach(item => {
        const link = item.querySelector('.nav-link');
        if (link) {
          const dropdownItem = document.createElement('a');
          dropdownItem.className = 'dropdown-item';
          dropdownItem.href = link.href;
          dropdownItem.textContent = link.textContent.trim();
          
          if (link.classList.contains('active')) {
            dropdownItem.classList.add('active');
          }
          if (link.getAttribute('aria-current')) {
            dropdownItem.setAttribute('aria-current', link.getAttribute('aria-current'));
          }
          
          navMoreDropdown.appendChild(dropdownItem);
          item.remove();
        }
      });

      // Update counter with number of items in dropdown
      const dropdownItemCount = navMoreDropdown.children.length;
      updateCounter(dropdownItemCount);

      // If no items were moved to More menu, hide it
      if (dropdownItemCount === 0) {
        navMoreMenu.style.display = 'none';
      } else {
        // Make remaining visible items grow to fill available space
        const remainingItems = navLinksGroup.querySelectorAll('.nav-item:not(.nav-more-menu)');
        remainingItems.forEach(item => {
          item.style.flex = '1 1 auto';
        });
      }
    }

    // Position dropdown menu using fixed positioning relative to viewport
    function positionDropdown() {
      const moreButton = navMoreMenu.querySelector('.nav-more-button');
      if (!moreButton) return;
      
      const buttonRect = moreButton.getBoundingClientRect();
      
      // Position dropdown below the button, aligned to the right
      navMoreDropdown.style.top = `${buttonRect.bottom + 4}px`;
      navMoreDropdown.style.right = `${window.innerWidth - buttonRect.right}px`;
      navMoreDropdown.style.left = 'auto';
    }

    // Initialize dropdown toggle behavior
    function initDropdown() {
      const moreButton = navMoreMenu.querySelector('.nav-more-button');
      if (!moreButton || moreButton.dataset.initialized === 'true') return;
      
      moreButton.dataset.initialized = 'true';
      
      moreButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = navMoreDropdown.classList.contains('show');
        
        if (isOpen) {
          navMoreDropdown.classList.remove('show');
          navMoreMenu.classList.remove('show');
          moreButton.setAttribute('aria-expanded', 'false');
        } else {
          // Position dropdown before showing
          positionDropdown();
          navMoreDropdown.classList.add('show');
          navMoreMenu.classList.add('show');
          moreButton.setAttribute('aria-expanded', 'true');
        }
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!navMoreMenu.contains(e.target) && navMoreDropdown.classList.contains('show')) {
          navMoreDropdown.classList.remove('show');
          navMoreMenu.classList.remove('show');
          moreButton.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Reposition dropdown on scroll (since it's fixed positioned)
      window.addEventListener('scroll', () => {
        if (navMoreDropdown.classList.contains('show')) {
          positionDropdown();
        }
      }, true);
    }

    // Run overflow check with proper timing
    function runCheck() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          checkOverflow();
        });
      });
    }

    // Initial setup
    initDropdown();
    runCheck();

    // Use ResizeObserver for better performance than resize event
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
    
    resizeObserver = new ResizeObserver(() => {
      runCheck();
    });
    
    resizeObserver.observe(navbar);
    if (titleWrapper) {
      resizeObserver.observe(titleWrapper);
    }
    
    // Observe sidebar for open/close state changes
    const sidebar = document.querySelector('.sidebar');
    if (sidebar) {
      resizeObserver.observe(sidebar);
    }

    // Also listen to window resize for viewport changes
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(runCheck, 50);
    };
    
    window.removeEventListener('resize', handleResize);
    window.addEventListener('resize', handleResize);

    isInitialized = true;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStudyNavbar);
  } else {
    initStudyNavbar();
  }

  // Support for jQuery and Turbolinks if available
  if (typeof $ !== 'undefined') {
    $(document).ready(function() {
      if (!isInitialized) {
        initStudyNavbar();
      }
    });
    
    $(document).on('turbolinks:load', function() {
      isInitialized = false;
      initStudyNavbar();
    });
  }
})();
